export var zIndexTableHeader = 300;
export var zIndexModal = 1000;
export var zIndexSearchSuggestionsList = 1024;